import {
  Building2,
  Calendar,
  ChartColumnBig,
  FileText,
  Pill,
  Stethoscope,
  Wallet,
} from 'lucide-react';

/** Category → icon used by both the report catalog and the selected-report header. */
export const REPORT_CATEGORY_ICONS: Record<string, typeof FileText> = {
  OPD: Stethoscope,
  IPD: Building2,
  Patients: FileText,
  Lab: ChartColumnBig,
  Radiology: ChartColumnBig,
  Financial: Wallet,
  HR: FileText,
  Appointments: Calendar,
  Pharmacy: Pill,
};

export function reportCategoryIcon(category: string): typeof FileText {
  return REPORT_CATEGORY_ICONS[category] ?? FileText;
}
